import { defineComponent as n, createBlock as o, openBlock as p, unref as i, withCtx as r, renderSlot as l, createTextVNode as s, createElementVNode as a } from "vue";
import { ScalarSearchResultItem as u } from "@scalar/components";
const d = ["innerHTML"], _ = /* @__PURE__ */ n({
  __name: "TypesenseSearchResult",
  props: {
    snippet: {}
  },
  setup(c) {
    return (t, e) => (p(), o(i(u), { icon: "DocsPage" }, {
      description: r(() => [
        e[0] || (e[0] = s(" …", -1)),
        a("span", {
          class: "guides-search-results-snippet",
          innerHTML: t.snippet
        }, null, 8, d),
        e[1] || (e[1] = s("… ", -1))
      ]),
      default: r(() => [
        l(t.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }));
  }
});
export {
  _ as default
};
